import { NgModule } from '@angular/core';
import { MatSliderModule } from '@angular/material/slider';
import { SharedModule } from '../../shared.module';
import { MyProgressComponent } from '../myProgress/my-progress.component';
import { InterestSurveyComponent, InterestSurveyEditScoreDialog } from '../../interestSurvey/interest-survey.component';
import { SkillProfilerComponent } from '../../skillProfiler/skillsMatcher/skill-profiler.component';
import { BeginCareerExplorationComponent } from '../../career/career.component';


@NgModule({
	imports: [
		MatSliderModule,
		SharedModule
	],
	declarations: [
		MyProgressComponent,
		InterestSurveyComponent,
		InterestSurveyEditScoreDialog,
		SkillProfilerComponent,
		BeginCareerExplorationComponent,
	],
	exports: [
		MyProgressComponent,
		InterestSurveyComponent,
		InterestSurveyEditScoreDialog,
		SkillProfilerComponent,
		BeginCareerExplorationComponent,
	]
})
export class MyProgressComponentModule { }
